import { useNavigate } from "react-router-dom";
import { useAppContext } from "../AppContext";
import thanksyou from "../assets/thumbsup.jpg";
import { Helmet } from "react-helmet-async";

export default function DownloadPage() {
  const { email, setEmail, setBuyNow } = useAppContext();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        <title>Thank You</title>
      </Helmet>
      <div className="relative bg-[#F8F8F8] overflow-hidden min-h-screen">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-10 left-10 w-16 h-16 bg-white/20 rounded-full animate-bounce" />
          <div className="absolute top-32 right-20 w-12 h-12 bg-white/15 rounded-full animate-bounce" />
          <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-white/10 rounded-full animate-bounce" />
          <div className="absolute top-1/2 right-10 w-8 h-8 bg-white/25 rounded-full animate-bounce" />
          <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-white/15 rounded-full animate-bounce" />
        </div>
        <div className="relative z-10 container mx-auto min-h-screen flex items-center justify-center p-6">
          <div className="w-full max-w-2xl rounded-xl shadow-2xl bg-gray-50 border-3 border-[#4E6978] overflow-hidden">
            <div className="bg-slate-100 px-6 py-4 border-b border-slate-200">
              <span className="text-xl font-medium mt-2 text-[#4E6978] ">
                Confirmation
              </span>
            </div>
            <div className="px-8 py-10">
              <div className="flex items-start gap-4">
                {/* circle hand icon */}
                <div className="shrink-0">
                  <span className="inline-flex items-center justify-center w-20 h-20 rounded-full">
                    <img src={thanksyou} alt="Thank you" />
                  </span>
                </div>
                <div>
                  <p className="text-[#F09900] font-semibold leading-tight">
                    You Rock!
                  </p>
                  <h1 className="text-2xl font-extrabold text-slate-800 tracking-tight">
                    Thank You!
                  </h1>
                </div>
              </div>
              {/* copy */}
              <div className="mt-8 space-y-5 leading-7 text-[16px] font-medium text-[#4E6978]">
                <p>
                  We've sent a confirmation email to{" "}
                  <span className="font-semibold">{email || "you"}</span> with your order details.
                </p>
                <p>
                  The email includes your receipt and a secure link to download your New Business Leads file. As a subscriber, you'll receive updated leads based on your selected frequency.
                </p>
                <p>
                  Thank you for your order. If you have any questions, reach out to us at{" "}
                  <a href="mailto:leadsnowproducts@gmail.com" className="text-[#F09900] font-semibold hover:underline">leadsnowproducts@gmail.com</a>.
                </p>
              </div>
              {/* footer button */}
              {/* <div className="mt-10 flex justify-end">
                <button
                  type="button"
                  className="inline-flex items-center rounded-md bg-[#26A94A] text-white px-5 py-2.5 font-semibold shadow hover:bg-emerald-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/60 cursor-pointer"
                  onClick={() => {
                    setEmail(""); // or setEmail(someValue)
                    navigate("/");
                    setBuyNow("home");
                  }}
                  style={{ color: "white" }}
                >
                  Back to the app!
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

